import { createApi } from '@reduxjs/toolkit/query/react';

import fetchBaseQuery from '@app/api/fetchBaseQuery';
import type { Project } from '@app/features/project';
import { projectsActions } from '@app/features/project';

export const ProjectTag = 'Project' as const;

const projectsApi = createApi({
    reducerPath: 'lokaliseInternal_projects',
    baseQuery: fetchBaseQuery(),
    tagTypes: [ProjectTag],
    endpoints: (builder) => ({
        getProjectStatistics: builder.query<GetProjectStatisticsResponse, GetProjectStatisticsRequest>({
            query: ({ projects }) => {
                const params = new URLSearchParams();
                projects.forEach((item, index) => {
                    params.append(`projects[${index}][id]`, item.id);
                    if (item.branch) {
                        params.append(`projects[${index}][branch]`, item.branch);
                    }
                });

                return {
                    method: 'GET',
                    url: '/projects/statistics',
                    params,
                };
            },
            providesTags: [ProjectTag],
            async onQueryStarted(id, { dispatch, queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled;
                    dispatch(projectsActions.updateProjectList(data));
                    // eslint-disable-next-line no-empty
                } catch (err) {}
            },
        }),
    }),
});

export type GetProjectStatisticsRequest = {
    projects: ProjectReference[];
};

export type ProjectReference = {
    id: string;
    branch?: string | null;
};

export type GetProjectStatisticsResponse = Project[];

export default projectsApi;

export const { useLazyGetProjectStatisticsQuery } = projectsApi;
